import Const from 'const';

class GroupSameLineups {
    constructor(private useGrouping: boolean = true) {}
    isUsed(): boolean {
        return this.useGrouping;
    }
}

const groupSameLineups = new GroupSameLineups();

export default function (state = groupSameLineups, action) {
    switch (action.type) {
        case Const.LATESWAP_GROUP_SAME_LINEUPS:
            return new GroupSameLineups(action.useGrouping);

        case Const.FILTER_BY_SLATE:
        case Const.RESET_ALL_SETTINGS:
            return new GroupSameLineups();

        default:
            return state;
    }
}
